export const ThreeDotsIcon = ({ color = "#666666", size = 12, ...props }) => (
    <svg
        width={size}
        height={size * (3 / 12)}
        viewBox="0 0 12 3"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3 1.5C3 0.675 2.325 -1.01629e-07 1.5 -6.55671e-08C0.675 -2.95052e-08 -1.01629e-07 0.675 -6.55671e-08 1.5C-2.95052e-08 2.325 0.675 3 1.5 3C2.325 3 3 2.325 3 1.5ZM4.5 1.5C4.5 2.325 5.175 3 6 3C6.825 3 7.5 2.325 7.5 1.5C7.5 0.675 6.825 -2.9833e-07 6 -2.62268e-07C5.175 -2.26206e-07 4.5 0.675 4.5 1.5ZM9 1.5C9 2.325 9.675 3 10.5 3C11.325 3 12 2.325 12 1.5C12 0.674999 11.325 -4.95031e-07 10.5 -4.5897e-07C9.675 -4.22908e-07 9 0.675 9 1.5Z"
            fill={color}
        />
    </svg>
);
